module.exports = __webpack_public_path__ + "img/354462a.jpg";